/**
 * The Site page's Plant Feed tile's strings (piece 28; decision 12503), spread
 * into the one lookup in `strings.ts`. 🔨 This file imports nothing, because the
 * lookup imports it.
 */
export const PLANT_FEED_STRINGS = {
  'plantFeed.loading': 'Reading the plant feed…',
  'plantFeed.none': 'This site sends no live data yet. Connect this Site gives its plant a broker user and a push key.',
  'plantFeed.connect': 'Connect This Site',
  'plantFeed.connected': 'The plant feed is connected. Copy the password and the key now: they are shown once and kept nowhere readable.',
  'plantFeed.secretsDone': 'I Have Copied Them',
  'plantFeed.siteKey': 'Site Key',
  'plantFeed.brokerUser': 'Broker User',
  'plantFeed.brokerPassword': 'Broker Password',
  'plantFeed.httpKey': 'HTTP Key',
  'plantFeed.brokerAddress': 'Broker Address',
  'plantFeed.noBroker': 'No broker is set up on this server, so the plant can send by the HTTP push alone.',
  'plantFeed.topics': 'Topics',
  'plantFeed.state': 'State',
  'plantFeed.since': 'Since',
  'plantFeed.lastHeard': 'Last Heard From',
  'plantFeed.never': 'Never',
  'plantFeed.clock': 'Clock Difference',
  'plantFeed.clockAhead': 'ahead',
  'plantFeed.clockBehind': 'behind',
  'plantFeed.clockSeconds': 's',
  'plantFeed.clockWarn': 'The controller’s clock is off by more than the warning allows; set it before its times are trusted.',
  'plantFeed.today': 'Today',
  'plantFeed.todayCounts': 'readings and faults received',
  'plantFeed.state.never': 'Never Heard',
  'plantFeed.state.online': 'Online',
  'plantFeed.state.offline': 'Offline',
  'plantFeed.state.silent': 'Silent',
  'plantFeed.outages': 'Outages',
  'plantFeed.outagesNone': 'None yet.',
  'plantFeed.outageOpen': 'still out',
  'plantFeed.source.device': 'Seen by the Device',
  'plantFeed.source.broker': 'Seen by the Broker',
  'plantFeed.source.silence': 'Seen as Silence',
  'plantFeed.maps': 'Mapped Tags',
  'plantFeed.mapsNone': 'No tag is mapped yet. Map Tag, or Import Devices once the plant has sent something.',
  'plantFeed.kind.reading': 'Reading',
  'plantFeed.kind.fault': 'Fault',
  'plantFeed.remove': 'Remove',
  'plantFeed.removed': 'The tag map was removed; the tag’s next readings are kept and refused until it is mapped again.',
  'plantFeed.mapTag': 'Map Tag',
  'plantFeed.importDevices': 'Import Devices',
  'plantFeed.importNone': 'Every tag the plant has sent is mapped.',
  'plantFeed.importHint': 'Tags the plant has sent that no map names. Their readings are kept and refused until each is mapped.',
  'plantFeed.received': 'received',
  'plantFeed.map': 'Map',
  'plantFeed.revoke': 'Revoke',
  'plantFeed.revokeSubject': 'the plant feed of',
  'plantFeed.revokePhrase': 'revoke',
  'plantFeed.revoked': 'The plant feed was revoked. The broker user is deleted, and the next publish or push is refused.',
  'plantFeed.form.title': 'Map a Tag',
  'plantFeed.form.save': 'Map the Tag',
  'plantFeed.form.tag': 'Tag',
  'plantFeed.form.tagHint': 'The tag’s name exactly as the device sends it.',
  'plantFeed.form.kind': 'Kind',
  'plantFeed.form.node': 'Node',
  'plantFeed.form.attribute': 'Attribute',
  'plantFeed.form.unit': 'Unit',
  'plantFeed.form.unitHint': 'The unit a reading means when it names none.',
  'plantFeed.form.unitNone': 'As the reading names it',
  'plantFeed.form.needsTag': 'Name the tag as the device sends it.',
  'plantFeed.form.needsNode': 'Pick the node the tag belongs to.',
  'plantFeed.form.needsAttribute': 'A reading names the attribute it writes.',
  'plantFeed.form.noNodes': 'This site has no asset tree yet; add its equipment before mapping a tag.',
} as const;
